import { Box, Card, CardContent, Typography } from '@mui/material';
import { WifiOff } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import type { ReactNode } from 'react';

type AdminOfflineGuardProps = {
  children: ReactNode;
  title?: string;
  message?: string;
  icon?: ReactNode;
};

export const AdminOfflineGuard = ({
  title,
  message,
  icon
}: AdminOfflineGuardProps) => {
  const { t } = useTranslation();

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100vh',
        padding: 3
      }}
    >
      <Card sx={{ maxWidth: 400, textAlign: 'center' }}>
        <CardContent sx={{ p: 4 }}>
          {icon || (
            <WifiOff
              sx={{
                fontSize: 64,
                color: 'text.secondary',
                mb: 2
              }}
            />
          )}
          <Typography variant="h5" gutterBottom>
            {title || t('common:offline.title')}
          </Typography>
          <Typography variant="body1" color="text.secondary">
            {message || t('common:offline.adminFeatures')}
          </Typography>
        </CardContent>
      </Card>
    </Box>
  );
};
